import { render, staticRenderFns } from "./GridWithExpansion.vue?vue&type=template&id=0aa65550&scoped=true&"
import script from "./GridWithExpansion.vue?vue&type=script&lang=js&"
export * from "./GridWithExpansion.vue?vue&type=script&lang=js&"
import style0 from "./GridWithExpansion.vue?vue&type=style&index=0&id=0aa65550&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa65550",
  null
  
)

export default component.exports